import React from "react";

function ResourcesContent() {
    return (
        <div className="main-content">
      <div className="rs-breadcrumbs breadcrumbs-overlay">
        <div className="breadcrumbs-img">
          <img src="assets/images/why.jpg" alt="Breadcrumbs " />
        </div>
        <div className="breadcrumbs-text white-color">
          <h1 className="page-title">Our Team</h1>
        </div>
      </div>

            <div className="rs-event orange-color pt-100 pb-100 md-pt-70 md-pb-70">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image1" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IIT Madras 'Entrepreneurship Summit 2022' to Feature More Than 800 Start-ups & 5,000 Students Across India
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image2" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IIT Madras Launches 'Venkataraman and Sita Srinivasan Chair' on Innovation
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image3" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Teaching Rural Children, Organic Farming and Ethics in AI
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image4" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IIT Madras Ranked #1 in Engineering by the National Institutional Ranking Framework (NIRF)
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image5" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IIT Madras Launches New Programme to Boost Women Leadership
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image6" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IIT Madras Rolls Out Women Leading IITM (WLI) Programme
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image7" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IIT Madras Launches New Program to Boost Women Leadership
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image8" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Follow IITM Alumni Subramonian Shankar, founder of American Megatrends
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image9" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            MOUSHIK: An Indigenous RISC-V Microprocessor of the SHAKTI family
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image10" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Veteran VC Kittu Kolluri has $216M more to invest through his new firm, Neotribe
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image11" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            U.S. Senate confirms Sethuraman Panchanathan's as NSF Director
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image12" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IITM Arise Standing Wheelchair: Allows the user to independently rise to a standing position.
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image13" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IIT Madras is India’s best engineering institute
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image14" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IIT Madras Alum-founded Startup geniSIGHTS launches Voice-Enabled AI to help enterprises reap actionable insights from data
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image14" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Passage AI Named a 2018 TiE50 Winner
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image15" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Sashi Narahari wins Distinguished Entrepreneurship award
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image16" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IITM Biotech Summit - June 3rd, 2018, Boston
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image17" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Applied Materials India to take up research in Artificial Intelligence
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image18" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Supercritical fluid extraction equipment.
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image19" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IITM students develop Intelligent Lighting Systems
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image20" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Tarun Mehta & Swapnil Jain: Electrifying scooters
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image21" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            IIT-Madras bags record Rs. 55 crore in alumni funds in 2016-17
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image22" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            List of Corporate Matching Program
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image23" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Annual Giving Report - 2016
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image24" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Decade of Giving
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image25" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Annual Giving Report 2015
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image26" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            The Gopalakrishnan‐Deshpande Center for Innovation and Entrepreneurship
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 mb-60 col-md-6">
                            <div className="event-item">
                                <div className="event-short">
                                    <div className="featured-img">
                                        <img src="assets/images/event/1.jpg" alt="Image27" />
                                    </div>
                                    <div className="content-part">
                                        <div className="address"><i className="fa fa-map-o"></i> VIEW ARTICLE</div>
                                        <p className="text">
                                            Strategic Plan
                                        </p>
                                        <div className="event-btm">
                                            <div className="btn-part">
                                                <a href="/">VIEW ARTICLE</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ResourcesContent;